module.exports = __webpack_public_path__ + "media/images/bg_1-96e420782240062ee4ec4f010610d10f.jpg";